module.exports = __webpack_public_path__ + "static/media/vectorpaint.ddef2cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorpaint.svg
// module id = 76
// module chunks = 0